/* eslint-disable */
import * as commfun from "@/common/common.js"
var index_mixins_shengshi = {
  data: function(){
    return {
      shengshi: [],// 省市机构树
      isshow: 2, // 1只显示省 2只显示省市 3只显示省市区
      codeToName: new Object(),// code对应区域名称
    }

  },
  created: function () {

  },
  methods: {
    getShengShi: function (other) {
      var selfthis = this
      // 省市数据来源:https://github.com/airyland/china-area-data/blob/master/v5/data.json

      var result = require('@/common/mixins/province.json')
      var trees = [];
      var sheng = result['86']
      for (var shengcode in sheng) {
        // console.log(shengcode+sheng[shengcode])
        var temp = [];
        temp['label'] = sheng[shengcode]
        temp['value'] = shengcode
        //输出省对应的名称
        selfthis.codeToName[shengcode] = temp['label']
        // 市
        if (selfthis.isshow >= 2) {
          temp['children'] = []
          temp['children'] = selfthis.getShi(result, shengcode)
        }

        trees.push(temp)
      }
      if (other != undefined) {
        trees.unshift(other)
      }
      selfthis.shengshi_data = trees;


    },// getShengShi
    getShi: function (result, shengcode) {
      var shi = [];
      if (result[shengcode] != undefined) {
        for (var shicode in result[shengcode]) {
          var tempshi = [];

          tempshi['label'] = result[shengcode][shicode]
          tempshi['value'] = shicode
          this.codeToName[shicode] = result[shengcode][shicode]
          //获取区
          if (result[shicode] != undefined && this.isshow > 2) tempshi['children'] = this.getqu(result, shicode)
          shi.push(tempshi)
          // }

        }
      }
      return shi;
    },//end getShi
    getqu: function (result, shicode) {
      var qu = [];
      if (result[shicode] != undefined) {
        for (var qucode in result[shicode]) {
          var temp = [];
          temp['label'] = result[shicode][qucode]
          temp['value'] = qucode
          this.codeToName[qucode] = result[shicode][qucode]
          qu.push(temp)
        }
      }
      return qu;
    },//end getqu
    getNameByCode: function (code) {
      var name = this.codeToName[code]
      return name;
    },
    getShengShiInfoByCode: function (code) {
      if(!code) return "";
      var cityinfo = new Object()
      var codeArr=code.split(',')
      if(codeArr[0] == ""||codeArr[0] == undefined) return ""
      var shengcode = codeArr[0]
      var shicode = codeArr[1]
      cityinfo['sheng'] = this.getNameByCode(shengcode)
      cityinfo['shi'] = this.getNameByCode(shicode)
      var str = cityinfo['sheng']+"-"+cityinfo['shi']
      return str
    }
  },

}

//导出minxin
export default index_mixins_shengshi



// WEBPACK FOOTER //
// ./src/common/mixins/index_mixins_shengshi.js